import { request } from "../../config/API";

const register = (data) => {
  return request.post("registrants", data, {
    headers: { "Content-Type": "application/json" },
  });
};

const login = (data) => {
  return request
    .post("login", data, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (response.data.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data.data.token));
      }
      return response.data;
    });
};
const twoFactorAtuh = (data) => {
  return request
    .post("twoFactorAuth", data, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (response.data.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data.data.token));
      }
      return response?.data;
    });
};
const forgotPassword = (data) => {
  return request
    .post("forgotPassword", data, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (response.data.data) {
      }
      return response.data;
    });
};
const resetPassword = (data) => {
  return request
    .post("resetPassword", data, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (response.data.data) {
      }
      return response.data;
    });
};
const logout = (user) => {
  request
    .post("logout", { user })
    .then(() => {})
    .catch((e) => {});
};

const getUpdatedUserInfo = () =>
  request.get(`user/getUser`).then((response) => {
    if (response.data.data) {
    }
    return response.data;
  });

const updateTourStatus = () =>
  request.put(`user/tourStatus`).then((response) => {
    if (response.data.data) {
    }
    return response.data;
  });
const authFunctions = {
  register,
  login,
  logout,
  forgotPassword,
  resetPassword,
  getUpdatedUserInfo,
  twoFactorAtuh,
  updateTourStatus,
};

export default authFunctions;
